import React, { useState, useEffect } from "react";

export const svg = `<svg width="48" height="48" viewbox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="24.02" cy="28.745" r="5.979" fill="#9E4AE0"></circle><path fill-rule="evenodd" clip-rule="evenodd" d="M18.137 21.968c-3.05-3.237-8.92-11.225-7.99-17.283C8.69 7.411 6.29 12.908 7.358 16.997a45.47 45.47 0 0 0 .775 2.64c.422 1.313.575 1.788.433 3.492-1.44-1.564-4.32-5.482-4.32-8.641-1.286 2.617-2.881 9.895 1.021 18.072 3.887.635 12.34 3.651 15.053 10.639l1.811-5.482c-1.966-.604-6.076-2.946-6.782-7.48-.707-4.534 1.564-7.402 2.787-8.27Zm11.8 0c3.051-3.237 8.92-11.225 7.991-17.283 1.456 2.726 3.856 8.223 2.788 12.312a45.499 45.499 0 0 1-.776 2.64c-.422 1.313-.574 1.788-.432 3.492 1.44-1.564 4.32-5.482 4.32-8.641 1.286 2.617 2.88 9.895-1.022 18.072-3.887.635-12.339 3.651-15.052 10.639l-1.812-5.482c1.967-.604 6.077-2.946 6.783-7.48.706-4.534-1.564-7.402-2.788-8.27Z" fill="#A4584E"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
